import React from 'react'
import StatisticContent from './Components/statistic';
import {Helmet} from 'react-helmet';
import StatisticHead from '../../Components/Head/Statistichead';


function Statistics() {
  return (
    <>
      <Helmet>
        <title>Rullier Admin</title>
      </Helmet>
      <div>
        <StatisticHead />
        <StatisticContent /> 
      </div>
    </>

  )
}

export default Statistics